var map = {
	"./gallery_00.jpg": 1901,
	"./gallery_01.jpg": 1902,
	"./gallery_02.jpg": 1903,
	"./gallery_03.jpg": 1904,
	"./gallery_04.jpg": 1905,
	"./gallery_05.jpg": 1906,
	"./gallery_06.jpg": 1907,
	"./gallery_07.jpg": 1908,
	"./gallery_08.jpg": 1909,
	"./gallery_09.jpg": 1910
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1900;